import $ from 'jquery';
import moment from "moment-timezone";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import SignaturePad from 'signature_pad';
import {vsprintf} from 'sprintf-js';
import Trumbowyg from 'trumbowyg';

export default {

    init() {

        // initial process
        this.process(document);

        // action wrapper, listen for scroll and resize events
        const actionbar = document.querySelector('.sonata-form-action-wrapper');

        if(actionbar) {
            const scroll = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    $(entry.target)
                        .css({height: entry.isIntersecting ? '' : $(entry.target).outerHeight(true)})
                        .children('.card').toggleClass('sonata-form-action-float', !entry.isIntersecting)
                }, {
                    root: null,   // default is the viewport
                    threshold: 1 // percentage of target's visible area. Triggers "onIntersection"
                })
            });

            // Use the observer to observe an element
            scroll.observe(document.querySelector('.sonata-form-action-wrapper'));
        }

        return this;
    },
    
    process(scope) {
        // file inputs
        this.processFileInputs(scope);

        // setup Flatpickr date widget
        this.processFlatpickr(scope);

        // setup SignaturePad signature canvas
        this.processSignaturePad(scope);

        // TrumboWYG
        this.processTrumbowyg(scope);

        // Formats
        this.processFormatInput(scope);

        $('[id^=sonata-ba-field-container-]').on('sonata.add_element', (event) => {
            const scope = $(event.target).find('.sonata-ba-tbody tr:last');
            this.processFileInputs(scope);
            this.processFlatpickr(scope);
            this.processSignaturePad(scope);
            this.processTrumbowyg(scope);
        });

        return this;
    },

    // expose this method for pages that do not depend on Sonata
    processSelect2(scope) {
        Admin.setup_select2(scope);
    },

    processFileInputs(scope) {
        $(scope).find('input[type=file]').on('change', function(e) {
            let title = e.target.files[0].name ?? Syn.trans('upload.select_files', [], 'SyndustryCommonBundle');
            $('label[for="'+this.id+'"] .text-truncate').text(title);
        });
    },

    processFlatpickr() {
        // init simple dates
        Syn.libs.Flatpickr(".flatpickr.date", {
            altInput:   true,
            altFormat:  moment.localeData().longDateFormat('L'),
            allowInput: true,                                          // allow direct input the have "required" working
            disableMobile: true,                                       // keep moment parse/format on mobile; native input would corrupt the "YYYY-MM-DD" value
            dateFormat: "YYYY-MM-DD",
            prevArrow:  "<span title=\"Previous month\">&laquo;</span>",
            nextArrow:  "<span title=\"Next month\">&raquo;</span>",
            parseDate: (datestr, format) => {
                // Parse as UTC to avoid timezone-induced off-by-one day shifts
                var m = moment.utc(datestr, format, true);
                if (!m.isValid()) {
                    m = moment.utc(datestr);
                }
                return new Date(m.year(), m.month(), m.date());
            },
            formatDate: (date, format, locale) => {
                // Format from the date's own Y/M/D components, NOT moment(date), which would
                // apply the user-profile timezone (moment.tz.setDefault) and shift date-only
                // values by one day when the profile TZ is behind the browser TZ. Combined with
                // the onClose re-parse below this previously caused the value to drift back a
                // day on every open/close.
                return Syn.libs.Moment([date.getFullYear(), date.getMonth(), date.getDate()]).format(format);
            },
            onClose(dates, currentdatestring, picker){
                // Use parseDate directly instead of passing altFormat to setDate,
                // because setDate's third arg uses flatpickr's native tokenizer
                // which misinterprets moment.js format tokens (e.g. DD/MM/YYYY).
                if (picker.altInput && picker.altInput.value) {
                    const parsed = picker.config.parseDate(picker.altInput.value, picker.config.altFormat);
                    if (parsed instanceof Date && !isNaN(parsed)) {
                        picker.setDate(parsed, true);
                    }
                }
            }
        });

        // init simple datetimes
        Syn.libs.Flatpickr(".flatpickr.datetime", {
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            time_24hr: true,
            altInput:   true,
            altFormat:  moment.localeData().longDateFormat('L') + " " + moment.localeData().longDateFormat('LT'),
            allowInput: true,                                          // allow direct input the have "required" working
            disableMobile: true,                                       // keep moment parse/format on mobile; native input would corrupt the submitted value
            prevArrow:  "<span title=\"Previous month\">&laquo;</span>",
            nextArrow:  "<span title=\"Next month\">&raquo;</span>",
            parseDate: (datestr, format) => {
                return Syn.libs.Moment(datestr, format, true).toDate();
            },
            formatDate: (date, format, locale) => {
                return Syn.libs.Moment(date).format(format);
            }
        });

        // init date ranges
        //
        // Each range is rendered as a pair of inputs (start/end), both carrying the
        // ".flatpickr.daterange" class. We initialise them as two INDEPENDENT date
        // pickers instead of a single linked range, so the user can submit only the
        // "from" date, only the "to" date, or both. The Sonata AbstractDateFilter
        // already supports one-sided ranges on the backend (>= for start, <= for end).
        $(".flatpickr.daterange").each((i, e) => {
            Syn.libs.Flatpickr($(e), {
                altInput:   true,
                dateFormat: "YYYY-MM-DD",
                altFormat:  moment.localeData().longDateFormat('L'),
                allowInput: true,                                          // allow direct input the have "required" working
                disableMobile: true,                                       // keep moment parse/format on mobile; native input would corrupt the "YYYY-MM-DD" value
                prevArrow:  "<span title=\"Previous month\">&laquo;</span>",
                nextArrow:  "<span title=\"Next month\">&raquo;</span>",
                parseDate: (datestr, format) => {
                    // Parse as UTC to avoid timezone-induced off-by-one day shifts
                    var m = moment.utc(datestr, format, true);
                    if (!m.isValid()) {
                        m = moment.utc(datestr);
                    }
                    return new Date(m.year(), m.month(), m.date());
                },
                formatDate: (date, format, locale) => {
                    // Timezone-agnostic for date-only fields (see simple .date picker above)
                    return Syn.libs.Moment([date.getFullYear(), date.getMonth(), date.getDate()]).format(format);
                },
                onClose(dates, currentdatestring, picker) {
                    if (picker.altInput && picker.altInput.value) {
                        const parsed = picker.config.parseDate(picker.altInput.value, picker.config.altFormat);
                        if (parsed instanceof Date && !isNaN(parsed)) {
                            picker.setDate(parsed, true);
                        }
                    }
                }
            });
        })

        let datetimeRangeIndex = 0;
        $(".flatpickr.datetimerange").each((i,e) => {

            // ranges come in pairs, skip every second daterange input
            if(i % 2 !== 0) {
                return;
            }

            const rangeId = 'filter-end-datetime-clone-' + datetimeRangeIndex;
            datetimeRangeIndex++;

            var endInput = $(e)
                            .parent('.form-floating')
                            .siblings('.form-floating')
                            .find('input')
                            .attr('type', 'text')
                            .get(0);

            // fix per https://github.com/flatpickr/flatpickr/issues/873
            Syn.libs.Flatpickr($(e), {
                "plugins": [new rangePlugin({ input: endInput })],
                enableTime: true,
                dateFormat: "Y-m-d H:i",
                altInput:   true,
                altFormat:  moment.localeData().longDateFormat('L') + " " + moment.localeData().longDateFormat('LT'),
                allowInput: true,
                disableMobile: true,                                       // keep moment parse/format on mobile; native input would corrupt the submitted value
                prevArrow:  "<span title=\"Previous month\">&laquo;</span>",
                nextArrow:  "<span title=\"Next month\">&raquo;</span>",
                parseDate: (datestr, format) => {
                    return Syn.libs.Moment(datestr, format, true).toDate();
                },
                formatDate: (date, format, locale) => {
                    return Syn.libs.Moment(date).format(format);
                },
                onReady: function(selectedDates) {

                    // Create a new hidden input with unique ID per range
                    const endDateInput = $(endInput);
                    const newInput = $('<input id="' + rangeId + '" class="form-control" type="hidden" name="'+endDateInput.attr('name')+'" />');
                    endDateInput.attr('name', 'disabled');

                    // Convert dates to strings
                    const dateArr = selectedDates.map(date => this.formatDate(date, "YYYY-MM-DD"));

                    // Set the selected value for start date input and append new from input
                    $(e).val(dateArr[0]);
                    newInput.insertBefore(endDateInput).val(dateArr[1]);
                },
                onChange: function(selectedDates) {
                    // Do the same after every update
                    const dateArr = selectedDates.map(date => this.formatDate(date, "YYYY-MM-DD"));

                    $(e).val(dateArr[0]);
                    $('#' + rangeId).val(dateArr[1]);
                }
            });

        })

    },

    processSignaturePad() {
        $('.signature-pad').each((i,e) => {
            // init
            var signaturePad = new SignaturePad(e, {});

            // store instance on element for external access (e.g. clear button)
            e._signaturePad = signaturePad;

            // update input when stroke done
            signaturePad.addEventListener("endStroke", () => {
                var input = document.getElementById(e.dataset.inputId);
                if(typeof input !== "object") {
                    console.warn("Signature file input not found");
                }
                input.setAttribute("value", e.toDataURL());
            }, { once: false });

            let resize = () => {
                const data = signaturePad.toData();
                var ratio   = Math.max(window.devicePixelRatio || 1, 1);
                e.width     = e.offsetWidth * ratio;
                e.height    = e.offsetHeight * ratio;
                e.getContext("2d").scale(ratio, ratio);
                signaturePad.fromData(data);
            };

            // add a resize listener for this canvas
            window.addEventListener("resize", resize);

            // and call it once
            resize();
        });

        // wire up clear buttons
        $(document).on('click', '.signature-pad-clear', function() {
            var inputId = $(this).data('input-id');
            var canvas  = $('.signature-pad[data-input-id="' + inputId + '"]').get(0);
            if (canvas && canvas._signaturePad) {
                canvas._signaturePad.clear();
                var input = document.getElementById(inputId);
                if (input) {
                    input.setAttribute('value', '');
                }
            }
        });
    },

    processTrumbowyg(scope) {
        $(scope).find('.syn_html textarea').trumbowyg({
            autogrow:   true,
            svgPath:    '/bundles/syndustrycommon/images/trumbowyg/icons.svg',
            btns: [
                ['viewHTML'],
                ['formatting'],
                'btnGrp-semantic',
                ['link'],
                ['insertImage'],
                'btnGrp-justify',
                'btnGrp-lists',
                ['horizontalRule'],
                ['removeformat'],
                ['fullscreen']
            ]
        })
            // .on('tbwinit', function(){
            //     var tbw = $(this).parent();
            //     tbw.data('y', tbw.outerHeight());
            // })
            // .on('tbwresize', function(){
            //     var tbw = $(this).parent();
            //     if( tbw.outerHeight() !== tbw.data('y') ) {
            //         tbw.data('y', tbw.outerHeight());
            //     }
            // })
        ;
    },

    processFormatInput(scope) {

        //format placeholder widget
        $("input[data-syn-format-placeholders]", scope).filter(":not(.syn_processed)").each(function(i,e){

            //only process once
            $(this).addClass('syn_processed');
            var placeholders = $.parseJSON( $(this).attr('data-syn-format-placeholders') );

            const container = $(this).parents('.format-container').eq(0);
            const dropdown = container.find('.dropdown-format-placeholders').eq(0);
            const example = container.find('.format-example').eq(0);

            const data = {};
            const sprint_args = [];
            const original = $(this);
            const input = $('<input/>').attr('type', 'text').addClass('form-control').val( original.val() );

            original.hide().parent().prepend(input);

            $.each(placeholders, function( i, ph ) {
                data[ph.display] = {
                    id: ph.format,
                    display: ph.display,
                    example: ph.example,
                    format: ph.format
                };
                sprint_args.push(ph.example);
                input.val( input.val().replaceAll(ph.format, "{" + ph.display + "}" ) );

                $(dropdown).append(
                    $('<a/>')
                        .addClass("dropdown-item")
                        .html(ph.display)
                        .on('click', () => {
                            input.val(
                                input.val().substring(0, input.get(0).selectionStart )
                                + "{" + ph.display + "}"
                                + input.val().substring(input.get(0).selectionStart, input.val().length )
                            ).change();
                            return false;
                        }
                    ).wrap($('<li/>')).parent()
                );
            });

            input.change(function() {
                var sprint  = $(this).val();
                var result  = $(this).val().match(/\{.*?\}/g);
                if( result ) {
                    $.each( result, function(i,e){
                        var item = data[ e.substring(1, e.length - 1 ) ];
                        if( item ) {
                            sprint = sprint.replace(e, item.format );
                        }
                    });
                    example.html( vsprintf(sprint, sprint_args) );
                }
                original.val(sprint);
            });

            input.change();
        });
    }
}